import APIClient from '@/shared/http/clients/api'

const resourceName = 'gruporeembolsoviagem'
const APICore = process.env.APIBaseURLCore

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const GroupRefundTravelRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete
}

export default GroupRefundTravelRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/grouprefundtravel.js